import { styled } from "styled-components";

import { Icon, Label } from "simplydo/react/ui";

import type { AssessmentRound } from "./types";

const SelectableWrapper = styled.span<{ $selected?: boolean }>`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  cursor: pointer;
  border-radius: 4px;
  opacity: ${({ $selected }) => ($selected ? 1 : 0.85)};

  &:hover {
    opacity: 1;
  }
`;

export const RoundLabelsGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-end;
`;

type AssessmentRoundLabelProps = {
  assessmentRound?: AssessmentRound;
  onDelete?: () => void;
  selectable?: boolean;
  selected?: boolean;
  onToggle?: () => void;
};

export const AssessmentRoundLabel = ({
  assessmentRound,
  onDelete,
  selectable,
  selected,
  onToggle,
}: AssessmentRoundLabelProps) => {
  const label = (
    <Label size="tiny" image color={selected ? "secondary" : "grey"}>
      {assessmentRound?.name || "Assessment"}
      {selectable ?
        <Label.Detail as="span">
          <Icon
            name={selected ? "check circle outline" : "circle outline"}
            style={{ margin: 0 }}
          />
        </Label.Detail>
      : onDelete ?
        <Label.Detail
          onClick={() => {
            onDelete();
          }}
          as="a"
          aria-role="button"
        >
          <Icon name="trash" style={{ margin: 0 }} />
        </Label.Detail>
      : null}
    </Label>
  );

  if (selectable) {
    return (
      <SelectableWrapper
        $selected={selected}
        onClick={onToggle}
        role="button"
        aria-pressed={selected}
      >
        {label}
      </SelectableWrapper>
    );
  }

  return label;
};
